import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';

import { UserLayoutComponent } from './layouts/user-layout/user-layout.component';
import { LoginLayoutComponent } from './layouts/login-layout/login-layout.component';
import { RedirectPolicyComponent } from './back-office/redirect-policy/redirect-policy.component';
import { RedirectTermsAndConditionComponent } from './back-office/redirect-terms-and-condition/redirect-terms-and-condition.component';
import { RedirectFaqComponent } from './back-office/redirect-faq/redirect-faq.component';
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AdminLoginLayoutComponent } from './layouts/admin-login-layout/admin-login-layout.component';
import { RedirectAboutUsComponent } from './back-office/redirect-about-us/redirect-about-us.component';
import { GetPaymentComponent } from './back-office/get-payment/get-payment.component';
import { GovernmentTravelAdvice } from './back-office/government-travel-advice/government-travel-advice.component';
import { PrivacyStatement } from './back-office/privacy-statement/privacy-statement.component';
import { RulesAndRestrictionComponent } from './back-office/rules-and-restriction/rules-and-restriction.component';
import { TermsOfUseComponent } from './back-office/terms-of-use/terms-of-use.component';
import { KumbhComponent } from './back-office/kumbh/kumbh.component';
import { MobileDeleteAccountAdvisaryComponent } from './back-office/mobile-delete-account-advisary/mobile-delete-account-advisary.component';


const routes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    }, {
        path: '',
        component: UserLayoutComponent,
        children: [{
            path: '',
            loadChildren: './layouts/user-layout/user-layout.module#UserLayoutModule'
        }]
    }, {
        path: '',
        component: LoginLayoutComponent,
        children: [{
            path: '',
            loadChildren: './layouts/login-layout/login-layout.module#LoginLayoutModule'
        }]
    },
    {
        path: 'admin',
        redirectTo: 'admin/login',
        pathMatch: 'full',
    },
    {
        path: 'admin',
        component: AdminLayoutComponent,
        children: [{
            path: '',
            loadChildren: './layouts/admin-layout/admin-layout.module#AdminLayoutModule'
        }]
    }, {
        path: 'admin',
        component: AdminLoginLayoutComponent,
        children: [{
            path: '',
            loadChildren: './layouts/admin-login-layout/admin-login-layout.module#AdminLoginLayoutModule'
        }]
    },
    {
        path: 'pilgrimPath/privacy-policy',
        component: RedirectPolicyComponent,
    },
    {
        path: 'pilgrimPath/terms-and-condition',
        component: RedirectTermsAndConditionComponent,
    },
    {
        path: 'pilgrimPath/faq',
        component: RedirectFaqComponent,
    },
    {
        path: 'payment/:id',
        component: GetPaymentComponent,
    },
    {
        path: 'pilgrimPath/about-us',
        component: RedirectAboutUsComponent,
    },
    {
        path: 'pilgrimPath/about-us',
        component: RedirectAboutUsComponent,
    },
    {
        path: 'delete-account-advisory',
        component: MobileDeleteAccountAdvisaryComponent,
    },
];

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled', 
            anchorScrolling: 'enabled' 
        })
    ],
    exports: [
    ],
})
export class AppRoutingModule { }
